import { axiosInstanceLive } from 'instance/Axios';
import { handleCatchError } from 'utils/CatchHandler';

const commonEndPoint = 'api/V2/';
const latitude = localStorage.getItem('latitude');
const longitude = localStorage.getItem('longitude');

const handleApiRequest = async (method, endpoint, payload = null) => {
    try {
        const response =
            method === 'GET'
                ? await merchantCommonGetRequest(endpoint, payload) // Pass params for GET
                : await merchantCommonPost(endpoint, payload); // Pass body for POST

        return response;
    } catch (error) {
        console.error('API Error:', error);
        return null;
    }
};
const merchantCommonPost = async (apiEndPoint, payload) => {
    const cleanEndPoint = apiEndPoint.replace(/^V2\//, '');
    const endPoint = commonEndPoint + cleanEndPoint;
    const token = localStorage.getItem('token');
    let merchantEmpID;
    const isEmployee = localStorage.getItem('isEmployee');
    if (isEmployee === 'true') {
        merchantEmpID = localStorage.getItem('empId');
    }
    const headers = {
        Authorization: `Bearer ${token}`,
        'Header-Merchant-Employee': merchantEmpID,
        'Content-Type': 'application/json',
        'X-Latitude': latitude,
        'X-Longitude': longitude
    };
    if (payload instanceof FormData) {
        delete headers['Content-Type'];
    }

    try {
        const response = await axiosInstanceLive.post(
            endPoint,
            payload,

            {
                headers
            }
        );
        return response;
    } catch (error) {
        console.log(error);
        handleCatchError(error);
        return error;
    }
};
const merchantCommonGetRequest = async (apiEndPoint, params) => {
    const endPoint = commonEndPoint + apiEndPoint;
    const token = localStorage.getItem('token');
    let merchantEmpID;
    const isEmployee = localStorage.getItem('isEmployee');
    if (isEmployee === 'true') {
        merchantEmpID = localStorage.getItem('empId');
    }
    const headers = {
        Authorization: `Bearer ${token}`,
        'Header-Merchant-Employee': merchantEmpID,
        'Content-Type': 'application/json',
        'X-Latitude': latitude,
        'X-Longitude': longitude
    };
    try {
        const response = await axiosInstanceLive.get(
            endPoint,

            {
                headers,
                params
            }
        );
        return response;
    } catch (error) {
        console.log(error);
        handleCatchError(error);
        return error;
    }
};

export const GET_API_ENDPOINTS = {
    states: 'hr/states',
    ditrict: 'hr/district',
    city: 'hr/fetchCity',
    designations: 'hr/employee/designations',
    fetchBank: 'hr/fetchBank'
};
export const POST_API_ENDPOINTS = {
    storeSalary: 'hr/storeSalary',
    listEmployee: 'hr/employee/list',
    storeEmployee: 'hr/employee/store',
    reportingManagers: 'hr/employee/reporting-managers',
    setTarget: 'hr/setTarget',
    hrDashboard: 'hr/employee/dashboard',
    addEmployeePortalStatus: 'hr/addEmployeePortalStatus',
    employeeTermination: 'hr/employeeTermination',
    salaryList: 'hr/salary/list',
    updateStatus: 'hr/employee/update-status',
    listTarget: 'hr/listTarget',
    getTargetMatrix: 'hr/getTargetMatrix',
    getTargetMatrixV2: 'hr/getTargetMatrixV3',
    employeePortalList: 'hr/getEmployeePortalList',
    hierarchy: 'hr/employee/hierarchy',
    kpiList: 'hr/kpisList',
    storeKpi: 'hr/kpisCreate',
    kpiUpdate: 'hr/kpisUpdate',
    deleteTarget: 'hr/deleteTarget',
    editTarget: 'hr/editTarget',
    fileUpload: 'hr/fileUpload',
    viewEmployee: 'hr/employee/view',
    addKpiTarget: 'hr/addKpiTarget',
    listKpiTarget: 'hr/listKpiTarget',
    setKpiEmployeeTarget: 'hr/setKpiEmployeeTarget',
    employeeCreditLimits: 'hr/employee-credit-limits',
    employeeCreditPaid: 'hr/mark-credit-paid',
    employeeUpdateCreditLimit: 'hr/update-credit-limit',
    creditEmployeeBalance: 'hr/credit-employee-balance',
    debitEmployeeBalance: 'hr/debit-employee-balance',
    uploadCreditBalance: 'hr/upload-credit-balance',
    listBalanceAdjustments: 'hr/list-balance-adjustments',
    onboardEmployee: 'hr/onboard-employee',
    deactivateEmployee: 'hr/deactivate-employee',
    uploadCreditOutstanding: 'hr/upload-credit-outstanding'
};
export const storeSalary = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.storeSalary, payload);
export const listEmployees = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.listEmployee, payload);
export const storeEmployee = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.storeEmployee, payload);
export const getReportingManagers = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.reportingManagers, payload);
export const setTargetApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.setTarget, payload);
export function fetchHrDashboardData(payload) {
    return handleApiRequest('POST', POST_API_ENDPOINTS.hrDashboard, payload);
}
export const getStates = (params) => handleApiRequest('GET', GET_API_ENDPOINTS.states, params);
export const getDistricts = (params) => handleApiRequest('GET', GET_API_ENDPOINTS.ditrict, params);
export const getCities = (params) => handleApiRequest('GET', GET_API_ENDPOINTS.city, params);
export const getEmployeePortalList = (params) => handleApiRequest('POST', POST_API_ENDPOINTS.employeePortalList, params);
export const addEmployeePortalStatus = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.addEmployeePortalStatus, payload);
export const employeeTermination = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.employeeTermination, payload);
export const salaryList = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.salaryList, payload);
export const updateEmployeeStatus = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.updateStatus, payload);
export const listTargetApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.listTarget, payload);
export const getTargetMatrixApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.getTargetMatrix, payload);
export const getTargetMatrixV2Api = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.getTargetMatrixV2, payload);
export const getHierarchy = (params) => handleApiRequest('POST', POST_API_ENDPOINTS.hierarchy, params);
export const kpiListApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.kpiList, payload);
export const storeKpiApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.storeKpi, payload);
export const kpiUpdateApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.kpiUpdate, payload);
export const deleteTargetApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.deleteTarget, payload);
export const editTargetApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.editTarget, payload);
export const fileUploadApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.fileUpload, payload);
export const getDesignations = (params) => handleApiRequest('GET', GET_API_ENDPOINTS.designations, params);
export const fetchBank = (params) => handleApiRequest('GET', GET_API_ENDPOINTS.fetchBank, params);
export const viewEmployee = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.viewEmployee, payload);
export const addKpiTargetApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.addKpiTarget, payload);
export const listKpiTargetApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.listKpiTarget, payload);
export const setKpiEmployeeTargetApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.setKpiEmployeeTarget, payload);
export const employeeCreditLimitsApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.employeeCreditLimits, payload);
export const employeeCreditPaidApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.employeeCreditPaid, payload);
export const employeeUpdateCreditLimitApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.employeeUpdateCreditLimit, payload);
export const creditEmployeeBalanceApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.creditEmployeeBalance, payload);
export const creditEmployeeBalance = creditEmployeeBalanceApi;
export const debitEmployeeBalanceApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.debitEmployeeBalance, payload);
export const debitEmployeeBalance = debitEmployeeBalanceApi;
export const uploadCreditBalanceApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.uploadCreditBalance, payload);
export const uploadCreditBalance = uploadCreditBalanceApi;
export const listBalanceAdjustmentsApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.listBalanceAdjustments, payload);
export const listBalanceAdjustments = listBalanceAdjustmentsApi;
export const onboardEmployeeApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.onboardEmployee, payload);
export const deactivateEmployeeApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.deactivateEmployee, payload);
export const uploadCreditOutstandingApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.uploadCreditOutstanding, payload);
